import { render } from "./index.vue?vue&type=template&id=3901569f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3901569f&lang=scss&scoped=true"

import exportComponent from "/home/workspace/cf-dkf-web-micro-base-interior-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3901569f"]])

export default __exports__